<template>
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M12 20V4M12 4L8 8M12 4L16 8"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
      vector-effect="non-scaling-stroke"
    />
  </svg>
</template>
